import { Component } from "react";

class CourseInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }
  render() { 
    return ( 
      <div className="text-sm mt-1 flex items-center flex-wrap">
        <div className="self-start inline-flex items-bottom flex-wrap gap-1">
          {this.props.children[0]}
          <h4 className="text-orange font-t-semibold mr-1">{this.props.label}
          </h4>
        </div>
        {this.props.children[1]}
      </div>
     );
  }
}
 
export default CourseInfo;